'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Input = require('../Input.scss');

var _Input2 = _interopRequireDefault(_Input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Unit = function Unit(_ref) {
  var children = _ref.children,
      value = _ref.value;
  return _react2.default.createElement(
    'div',
    { className: _Input2.default.unit, 'data-hook': 'unit' },
    value || children
  );
};

Unit.displayName = 'Input.Unit';
Unit.propTypes = {
  children: _propTypes2.default.node,
  value: _propTypes2.default.string
};

exports.default = Unit;


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-style-react/dist/src/Input/Unit/Unit.js
// module id = 1340
// module chunks = 0